<template>
  <header class="page-header" :class="{ 'is-sub': back }">
    <button v-if="back" class="back-button" type="button" aria-label="返回" @click="$emit('back')">
      <app-icon name="back" />
    </button>
    <div class="page-header-title">
      <h1>{{ title }}</h1>
      <p v-if="subtitle">{{ subtitle }}</p>
    </div>
    <div class="header-actions">
      <slot />
    </div>
  </header>
</template>
<script>
export default { props: { title: String, subtitle: String, back: Boolean } }
</script>



// WEBPACK FOOTER //
// src/components/page-header.vue